import type { SalesFlowNode, SalesFlowRunLog } from '@/lib/api/sales/flows-api'
import { format } from 'date-fns'
import { FLOW_HANDLE_LABELS, FLOW_LOG_STATUS, FLOW_NODE_META } from '../flow-meta'

/** Passos de uma execução, em ordem, com o motivo de cada um. */
export default function RunLogTimeline({ logs, nodes }: { logs: SalesFlowRunLog[]; nodes: SalesFlowNode[] }) {
    if (!logs.length) return <p className="text-sm text-base-content/50">Nenhum passo registrado.</p>
    const byKey = new Map(nodes.map(n => [n.key, n]))
    return (
        <ol className="relative space-y-3 border-l border-base-300 pl-5">
            {logs.map(log => {
                const node = byKey.get(log.nodeKey)
                const status = FLOW_LOG_STATUS[log.status] ?? { label: log.status, badge: 'badge-ghost' }
                return (
                    <li key={log.id} className="relative">
                        <span className="absolute -left-[27px] top-1.5 h-3 w-3 rounded-full border-2 border-base-100 bg-primary" />
                        <div className="flex flex-wrap items-center gap-2">
                            <span className="text-sm font-medium">{node ? FLOW_NODE_META[node.type].label : log.nodeKey}</span>
                            <span className={`badge badge-sm ${status.badge}`}>{status.label}</span>
                            {log.handle && <span className="badge badge-outline badge-sm">{FLOW_HANDLE_LABELS[log.handle] ?? log.handle}</span>}
                            <span className="ml-auto text-xs text-base-content/40">{format(new Date(log.createdAt), 'dd/MM HH:mm:ss')}</span>
                        </div>
                        {log.detail && <p className="mt-1 whitespace-pre-wrap break-words text-xs leading-relaxed text-base-content/70">{log.detail}</p>}
                    </li>
                )
            })}
        </ol>
    )
}
